var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFiltrationRegistration = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43476 4.06561C8.41107 5.04191 8.41107 6.62483 7.43476 7.60114C6.45845 8.57745 4.87553 8.57745 3.89922 7.60114C2.92292 6.62483 2.92292 5.04191 3.89922 4.06561C4.87553 3.0893 6.45845 3.0893 7.43476 4.06561",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 5.83341H8.16699",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4348 12.399C18.4111 13.3753 18.4111 14.9582 17.4348 15.9345C16.4584 16.9108 14.8755 16.9108 13.8992 15.9345C12.9229 14.9582 12.9229 13.3753 13.8992 12.399C14.8755 11.4227 16.4584 11.4227 17.4348 12.399",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00049 14.1667H13.1672",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFiltrationRegistration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FiltrationRegistration.1d63ea1a.svg";
export { ForwardRef as ReactComponent };